import { ValueProvider } from "@angular/core";
import { API_BASE_URL } from "./client";

export const provideApiBaseUrl = (apiBaseUrl: string): ValueProvider => ({ provide: API_BASE_URL, useValue: apiBaseUrl, multi: false });
